export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FacebookFeed.vue?vue&type=template&id=2661b238&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FacebookFeed.vue?vue&type=template&id=2661b238&
// module id = 129
// module chunks = 7